import { SearchFilters } from '../../search/schemas'
import { HierarchyPart, getHierarchyBreadcrumbs } from './hierarchy-breadcrumbs'
import { Breadcrumb } from './types'

export class CampsiteBreadcrumbsGenerator {
  get({
    searchFilters,
    hierarchies,
    noCategories = false,
  }: {
    hierarchies: HierarchyPart[]
    searchFilters: SearchFilters
    noCategories?: boolean
  }): Breadcrumb[] {
    return getHierarchyBreadcrumbs({
      hierarchies,
      filters: searchFilters,
      noCategories,
    })
  }
}
